module.exports = __webpack_public_path__ + "static/media/MIX_START.9917b38c.mp3";